import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "articles-list"
}
const _hoisted_2 = {
  key: 0,
  class: "card py-2 px-2"
}
const _hoisted_3 = { class: "py-1 px-2" }
const _hoisted_4 = { class: "py-1 nowrap" }
const _hoisted_5 = { class: "py-1 px-2 nowrap" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "card py-2 px-2"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_edit_article = _resolveComponent("edit-article")!
  const _component_delete_article = _resolveComponent("delete-article")!
  const _component_create_article = _resolveComponent("create-article")!
  const _component_create_author = _resolveComponent("create-author")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[3] || (_cache[3] = _createElementVNode("div", null, [
      _createElementVNode("h1", null, "Articles")
    ], -1)),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.articles.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("table", null, [
                  _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        class: "header-row py-2 px-2",
                        style: {"width":"40%"}
                      }, "Title"),
                      _createElementVNode("th", { class: "header-row py-2" }, "Date"),
                      _createElementVNode("th", { class: "header-row py-2 px-2" }, "Author"),
                      _createElementVNode("th", { class: "header-row py-2" })
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_3, _toDisplayString(article.title), 1),
                        _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.moment(article.published_on).format('YYYY-MM-DD')), 1),
                        _createElementVNode("td", _hoisted_5, _toDisplayString(article.full_name), 1),
                        _createElementVNode("td", null, [
                          (_openBlock(), _createBlock(_component_edit_article, {
                            "article-obj": article,
                            "authors-obj": _ctx.authors,
                            onUpdateArticleData: _ctx.updateArticle,
                            key: article.id
                          }, {
                            trigger: _withCtx((triggerProps) => [
                              _createElementVNode("button", {
                                onClick: triggerProps.click,
                                class: "ms-4 btn btn-primary btn-sm"
                              }, "Edit Article", 8, _hoisted_6)
                            ]),
                            _: 2
                          }, 1032, ["article-obj", "authors-obj", "onUpdateArticleData"])),
                          _cache[0] || (_cache[0] = _createTextVNode("   ")),
                          (_openBlock(), _createBlock(_component_delete_article, {
                            "article-obj": article,
                            onDeleteArticleData: ($event: any) => (_ctx.deleteArticle(index)),
                            key: article.id
                          }, {
                            trigger: _withCtx((triggerProps) => [
                              _createElementVNode("button", {
                                onClick: triggerProps.click,
                                class: "ms-4 btn btn-primary btn-sm"
                              }, "Delete", 8, _hoisted_7)
                            ]),
                            _: 2
                          }, 1032, ["article-obj", "onDeleteArticleData"]))
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[2] || (_cache[2] = [
                _createStaticVNode("<table><thead><tr><th class=\"header-row py-2 px-2\">Title</th><th class=\"header-row py-2\">Date</th><th class=\"header-row py-2\">Author</th><th class=\"header-row py-2\"></th></tr></thead><tbody><tr><td class=\"text-center\" colspan=\"4\">There are no articles at this time.</td></tr></tbody></table>", 1)
              ]))),
          _createVNode(_component_create_article, {
            onUpdate: _ctx.newArticle,
            "authors-obj": _ctx.authors
          }, {
            trigger: _withCtx((triggerProps) => [
              _createElementVNode("button", {
                onClick: triggerProps.click,
                class: "ms-2 my-4 btn btn-primary"
              }, "Create New Article", 8, _hoisted_9)
            ]),
            _: 1
          }, 8, ["onUpdate", "authors-obj"]),
          _createVNode(_component_create_author, { onUpdate: _ctx.newAuthor }, {
            trigger: _withCtx((triggerProps) => [
              _createElementVNode("button", {
                onClick: triggerProps.click,
                class: "ms-2 my-4 btn btn-primary"
              }, "Create New Author", 8, _hoisted_10)
            ]),
            _: 1
          }, 8, ["onUpdate"])
        ]))
      : _createCommentVNode("", true),
    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}